import React, { Component } from 'react';
import { reverse, take, sortBy, values } from 'lodash'
import { connect } from 'react-redux'
import { Panel, Button } from 'react-bootstrap'

import { getTicketTest } from '../lib/APIClient.js'
import styles from './TestPageStyles.js'

type PropsTrip = {
  id: string,
  name: string,
  requesting: boolean,
  onClick: () => void,
  filename: ?string,
  url: ?string,
  numPages: ?number
}

const Trip = ({ id, name, requesting, onClick, filename, numPages, url } = PropsTrip) =>  (
  <div style={numPages == 1 ? styles.correctItem : styles.errorItem}>
    <div>
      <a href={`/private/trip/${id}`}>{name || "Sin nombre"} ({id})</a>
      <Button bsStyle="primary" onClick={() => onClick()} style={{float: "right"}}>
        {requesting ? "Loading..." : "Refresh"}
      </Button>
    </div>
    { 
      filename && !requesting
        ? <embed src={`/${filename}`} width="300px" height="350px" />
        : "" 
    }
    <p>{numPages} páginas   (<a href={`/${filename}`}>PDF</a>,<a href={url}>page</a>)</p>
  </div>
)

type PropsTicketTest = {
  trips: [Object]
}

class TicketTest extends React.PureComponent
{
  constructor(props) {
    super(props)
    this.state = {
      requesting: {}, 
      numPages: {}, 
      filenames: {},
      urls: {},
    }
  }

  props : PropsTicketTest

  requestTest(tripId) {
    console.log("gonna request")
    this.setState({ requesting: Object.assign({}, this.state.requesting, {[tripId]: true}) })
    getTicketTest(tripId).then(x => {
      this.setState({ 
        requesting: Object.assign({}, this.state.requesting, {[tripId]: false}), 
        numPages:   Object.assign({}, this.state.numPages,   {[tripId]: x.numPages || "?"}), 
        filenames:  Object.assign({}, this.state.filenames,  {[tripId]: x.filename}), 
        urls:       Object.assign({}, this.state.urls,       {[tripId]: x.url}), 
      })
    })
  }

  requestAll() {
    this.props.trips.forEach(x => this.requestTest(x._id))
  }

  render() {
    return (
      <div>
        <Panel>
          <Panel.Body>
            <p>{JSON.stringify(this.state)}</p>
            <Button onClick={() => this.requestAll()}>Actualizar todos</Button>
          </Panel.Body>
        </Panel>
        <div style={styles.container}>
          {
            this.props.trips.map(trip => (
              <Trip 
                key={trip._id}
                id={trip._id} 
                name={trip.name || "No name"} 
                filename={this.state.filenames[trip._id]}
                url={this.state.urls[trip._id]}
                requesting={this.state.requesting[trip._id]}
                numPages={this.state.numPages[trip._id] || "?"}
                onClick={() => this.requestTest(trip._id)}
              />
            ))
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ 
  trips: !state.trips 
    ? [] 
    : (
      take(
        reverse(
          sortBy(
            values(state.trips).filter(t => !t.deleted && t.creation && t.name), 
            "creation"
          )
        ), 
        20
      )
    )
})

export default connect(mapStateToProps)(TicketTest)
